module.exports = __webpack_public_path__ + "static/media/bacon.fdeac002.svg";